// import { Button } from "../../Atoms/Button";
import React, { useState } from 'react';
import { SwitchTransition, Transition } from 'react-transition-group';
import { gsap } from 'gsap';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import bgRing from '../../Assets/home/product_carousel/circle.svg';

import capacity from '../../Assets/products_landing/capacity.svg';
import dc_30d from '../../Assets/products_landing/30 kW DC charger front view.png';
import dc_120d from '../../Assets/products_landing/DC Charger 60-240 kW front view.png';
import dc_240d from '../../Assets/products_landing/dc-c.png';
import type2 from '../../Assets/home/carousel_images/type2.svg';
import threePin from '../../Assets/home/carousel_images/3pin.svg';
import css2 from '../../Assets/home/carousel_images/ccs2.svg';
import css1 from '../../Assets/home/carousel_images/ccs2.svg';
import six0309 from '../../Assets/home/carousel_images/six0309.svg';
import ether from '../../Assets/home/carousel_images/ether.png';
import gsm from '../../Assets/home/carousel_images/gsm.png';
import wifi from '../../Assets/home/carousel_images/wifi.png';
import vehicle1 from '../../Assets/home/carousel_images/6.png';
import vehicle2 from '../../Assets/home/carousel_images/7.png';
import vehicle3 from '../../Assets/home/carousel_images/8.png';
import vehicle4 from '../../Assets/home/carousel_images/9.png';
import home from '../../Assets/home/newIcon/1.png';
import fleet from '../../Assets/home/newIcon/4.png';
import cpo from '../../Assets/home/CPO.png';
import realestate from '../../Assets/home/newIcon/5.png';
import retail from '../../Assets/home/newIcon/3.png';
import workplace from '../../Assets/home/newIcon/2.png';
import { Button } from '../../Atoms';
import { IoChevronForwardOutline } from 'react-icons/io5';
import { BsArrowRightShort } from 'react-icons/bs';
 

// docs

import FormModal from './FormModal';
import ARAIlogo from '../../Assets/products_landing/ARAIlogo.png';

export default function ACChargerFlex() {
  const [activeIdx, setActiveIdx] = useState(0);
  const connectivity = [
    { desc: 'GSM', icon: gsm },
    { icon: ether, desc: 'Ethernet' },
    { icon: wifi, desc: 'WiFi' },
  ];
  const socketType = [
    { desc: 'Type 2 ', icon: type2 },
    { desc: 'IEC 60309', icon: six0309 },
    { icon: threePin, desc: '3 Pin' },
    { desc: 'CCS1', icon: css1 },
    { desc: 'CCS2', icon: css2 },
  ];

  const CompatibilityType = [
    { desc: '', icon: vehicle3 },
    { desc: '', icon: vehicle2 },
    { icon: vehicle1, desc: '' },
    { desc: '', icon: vehicle4 },
  ];
  const userType = [
    { desc: 'Home', icon: home },
    { icon: fleet, desc: 'Fleet' },
    { desc: 'Real Estate', icon: realestate },
    { desc: 'Retail & Hospitality ', icon: retail },
    { desc: 'Workplace', icon: workplace },
  ];

  const tabData = [
    {
      title: 'Ksipra DC Charger 30 kW',
      desc: '',
      availFrom: 30,
      availTo: false,
      fileLink:
        'https://resources.verdemobility.com/files/30kwdcchargerpdf.pdf',
      imgSrc: dc_30d,
      socketType: [4],
      connectivity: [0, 1, 2],
      use: [1, 2, 3, 4],
      compatibility: [2, 3],
    },
    {
      title: 'Ksipra DC Charger 60 kW',
      desc: '',
      availFrom: 60,
      availTo: false,
      fileLink: 'https://resources.verdemobility.com/files/dccharger60240.pdf',
      imgSrc: dc_120d,
      socketType: [4],
      connectivity: [0, 1, 2],
      use: [1, 2, 3, 4],
      compatibility: [2, 3],
      icon: ARAIlogo,
    },
    {
      title: 'Ksipra DC Charger 120 kW',
      desc: '',
      availFrom: 120,
      availTo: false,
      fileLink: 'https://resources.verdemobility.com/files/dccharger60240.pdf',
      imgSrc:  dc_120d ,
      socketType: [4],
      connectivity: [0, 1, 2],
      use: [1],
      compatibility: [2, 3],
      icon: ARAIlogo,
    },
    {
      title: 'Ksipra DC Charger 240 kW',
      desc: '',
      availFrom: 240,
      availTo: false,
      fileLink: 'https://resources.verdemobility.com/files/dccharger60240.pdf',
      imgSrc: dc_240d,
      socketType: [4],
      connectivity: [0, 1, 2],
      use: [1],
      compatibility: [2, 3],
      icon: ARAIlogo,
    },
  ];

  const tabs = [
    'Ksipra DC 30S',
    'Ksipra DC 60D',
    'Ksipra DC 120D',
    'Ksipra DC 240D',
  ];

  const sliderSettings = {
    autoplay: true,
    autoplaySpeed: 10000,
    centerMode: true,
    dots: false,
    variableWidth: true,
    infinite: true,
    focusOnSelect: true,
    draggable: true,
    afterChange: (index) => {
      const isSmallDevice = window.innerWidth;
      if (isSmallDevice < 800) {
        setActiveIdx(index);
      }
    },
    responsive: [
      {
        breakpoint: 512,
        settings: {
          variableWidth: true,
          centerMode: true,
        },
      },
    ],
  };
  const sliderSettings2 = {
   autoplay: true,
    autoplaySpeed: 10000,
    centerMode: true,
    dots: false,
    variableWidth: true,
    infinite: true,
    focusOnSelect: true,
    draggable: true,
    afterChange: (index) => {
      const isSmallDevice = window.innerWidth;
      if (isSmallDevice < 800) {
        setActiveIdx(index);
      }
    },
    responsive: [
      {
        breakpoint: 512,
        settings: {
          variableWidth: true,
          centerMode: true,
        },
      },
    ],
  };

  const exitAnim = (node) => {
    gsap.to(node, {
      duration: 0.3,
      opacity: 0,
    });
  };
  const Chip = ({ data, type = false, userType = false }) => {
    const { desc, icon } = data;
    return (
      <div className="flex flex-nowrap gap-2 md:gap-3 items-center ">
        {icon && (
          <img
            loading="lazy"
            src={icon}
            alt={desc}
            className={`h-6 md:${
              type ? 'h-14' : 'h-8'
            } w-auto object-contain objet-center`}
            title={data?.title}
          />
        )}
        <span
          className={`${
            userType ? ' py-2 font-medium' : 'font-semibold'
          } text-sm sm:text-base lg:${
            userType ? 'text-base' : 'text-lg'
          }   font-poppins   `}
        >
          {desc}
        </span>
      </div>
    );
  };

  const enter = (node) => {
    gsap.fromTo(
      node,
      {
        opacity: 0,
      },
      {
        duration: 0.5,
        opacity: 1,
      }
    );
  };

  const [productTitle, setProductTitle] = useState('');

  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => {
    setIsModalOpen(true);
  };
  return (
    <>
      <section className="flex lg:flex-row flex-col-reverse gap-3  blade-margin-top-sm relative gap-y-6  bg-light-gradient">
        <div className=" basis-32  xl:basis-20 grow shrink  col-end-7 flex items-center  lg:justify-end md:pt-20 pb-0 px-3 pl-5 lg:pl-20 xl:pl-10">
          <SwitchTransition>
            <Transition
              appear={true}
              timeout={300}
              in={true}
              key={activeIdx}
              onExit={exitAnim}
              onEnter={enter}
              mountOnEnter
              unmountOnExit
            >
              <div className="basis-72 mr-0 xl:mr-0 grow shrink  max-w-xl  flex flex-col md:gap-4 xl:gap-4">
                <span className="flex xxl:text-[41px] xl:text-[40px] lg:text-[40px] md:text-[36px] text-[32px] xl:leading-tight lg:leading-tight md:leading-tight leading-normal font-gilroy font-semibold">
                  {tabData[activeIdx].title}
                  <img src={tabData[activeIdx].icon} className="ml-4" />
                </span>
                <p className="font-poppins font-light mt-2  text-base  md:text-xl  xl:text-2xl max-w-xl lg:w-full">
                  {tabData[activeIdx].desc}
                </p>
                <div className="flex flex-col divide-y divider-grey">
                  <div className="flex flex-row items-center flex-nowrap gap-4 py-2  sm:py-4">
                    <span className="font-poppins font-semibold  text-lg xl:text-xl">
                      Connectivity:
                    </span>
                    <div className="flex flex-wrap gap-2 items-center">
                      {tabData[activeIdx].connectivity.map((elem, index) => {
                        return (
                          <div key={index}>
                            <Chip data={connectivity[elem]} />
                          </div>
                        );
                      })}
                    </div>
                  </div>
                  <div className="flex flex-row items-center flex-nowrap gap-4 py-2  sm:py-3 lg:py-5">
                    <span className="font-poppins font-semibold  text-lg xl:text-xl">
                      Charging Capacity:
                    </span>
                    <div className="flex flex-wrap gap-3 items-center">
                      {tabData[activeIdx].availFrom && (
                        <Chip
                          data={{
                            desc:
                              tabData[activeIdx].availFrom +
                              ' kW' +
                              (tabData[activeIdx].availTo
                                ? ' to ' + tabData[activeIdx].availTo + ' kW'
                                : ''),
                            icon: capacity,
                          }}
                        />
                      )}
                    </div>
                  </div>
                  <div className="flex flex-row items-center flex-nowrap gap-4 py-2  sm:py-3 lg:py-5">
                    <span className="font-poppins font-semibold  text-lg xl:text-xl">
                      Plugs Available:
                    </span>
                    <div className="flex flex-wrap gap-2 items-center">
                      {tabData[activeIdx].socketType.map((elem, index) => {
                        return (
                          <div key={index}>
                            <Chip data={socketType[elem]} />
                          </div>
                        );
                      })}
                    </div>
                  </div>
                  <div className="flex items-center gap-4 py-2  sm:py-3 lg:py-5 block lg:hidden">
                    <span className="font-poppins font-semibold text-lg xl:text-xl">
                      Compatibility:
                    </span>
                    <div className="flex space-x-4">
                      {tabData[activeIdx].compatibility.map((elem, index) => {
                        return (
                          <div key={index}>
                            <Chip data={CompatibilityType[elem]} type="true" />
                          </div>
                        );
                      })}
                    </div>
                  </div>
                  <div className="gap-4 py-2  sm:py-3 lg:py-5 flex">
                    <span className="font-poppins font-semibold text-lg xl:text-x w-1/6">
                      Use Type:
                    </span>
                    <div className="flex items-center  flex-wrap w-5/6">
                      {tabData[activeIdx].use.map((elem, index) => {
                        return (
                          <div key={index} className="mr-4">
                            <Chip data={userType[elem]} userType="true" />
                          </div>
                        );
                      })}
                    </div>
                  </div>
                  <div className="flex items-center py-2 sm:py-3 gap-3">
                    <div
                      onClick={() => {
                        openModal();
                        setProductTitle(tabData[activeIdx].title);
                      }}
                    >
                      {/* <Button title="Contact Us" /> */}
                      <button className="btn-new font-semibold relative flex justify-center items-center rounded-full pl-16 pr-6 font-poppins">
                        <span className="flex justify-center items-center">
                          <IoChevronForwardOutline className="h-[22px] w-[25px] ioArrow" />
                          <BsArrowRightShort className="h-[30px] w-[30px] tailArrow" />
                        </span>
                        Contact Us
                      </button>
                    </div>

                    <div className="group cursor-pointer">
                      <a
                        href={tabData[activeIdx].fileLink}
                        target="_blank"
                        className="text-gray-600 group-hover:text-verde"
                      >
                        <button className="btn-new font-semibold relative flex justify-center items-center rounded-full pl-16 pr-6 font-poppins">
                          <span className="flex justify-center items-center">
                            <IoChevronForwardOutline className="h-[22px] w-[25px] ioArrow" />
                            <BsArrowRightShort className="h-[30px] w-[30px] tailArrow" />
                          </span>
                          Brochure
                        </button>
                      </a>
                    </div>
                  </div>
                </div>
                {/* <div className="flex flex-wrap gap-x-10 gap-y-6 items-center justify-start mt-3">
                  <div className="flex flex-nowrap gap-2 md:gap-3 items-center ">
                    <img
                      loading="lazy"
                      src={capacity}
                      alt="charging"
                      className=" h-6  md:h-8 w-auto object-contain objet-center"
                    />
                    <span className="text-sm sm:text-base lg:text-lg font-poppins font-semibold">
                      {tabData[activeIdx].availFrom +
                        ' kW' +
                        (tabData[activeIdx].availTo
                          ? ' to ' + tabData[activeIdx].availTo + ' kW'
                          : '')}
                    </span>
                  </div>
                  {tabData[activeIdx].socketType.map((elem) => {
                    return <Chip data={socketType[elem]} />;
                  })}
                </div>

                <div className="self-start">
                  <Button
                    onClick={() => {
                      window.open(tabData[activeIdx].fileLink);
                    }}
                    title="Learn More"
                    className="mt-4"
                  />
                </div> */}
              </div>
            </Transition>
          </SwitchTransition>
        </div>
        <div className=" top-auto left-0 bottom-0 right-0 lg:hidden block overflow-hidden">
          <Slider {...sliderSettings} className="lg:hidden block z-10">
            {tabs.map((elem, index) => {
              return (
                <button
                  key={index}
                  onClick={() => setActiveIdx(index)}
                  className={` ${
                    activeIdx === index
                      ? 'text-green border-green border rounded-xl'
                      : ''
                  } text-black hover:text-green font-poppins whitespace-nowrap text-base xl:text-lg py-2  px-3 grid place-content-center`}
                >
                  {elem}
                </button>
              );
            })}
          </Slider>
        </div>
        <div className="basis-80 grow shrink flex justify-center items-center relative min-h-[300px] sm:min-h-[400px] md:min-h-[550px] lg:min-h-[650px] xxl:min-h-[800px]">
          <div className="absolute top-0 left-auto bottom-0 right-0 bg-gradient w-32 md:w-56 lg:w-80"></div>

          <div className="mt-0 md:mt-10 mx-3 md:w-10/12  md:max-w-[850px] max-w-sm grid place-content-center md:px-10 lg:px-20  bg-grey z-10 h-5/6 lg:h-4/5 rounded-3xl overflow-hidden relative ">
            {/* <div className="object-contain absolute top-20 left-20 bottom-20 right-20">
              <img
                loading="lazy"
                src={bgRing}
                alt="presentational mockup for verdemobility product"
                className="w-9/12 mx-auto h-full object-center object-contain"
              />
            </div> */}
            {/* <Slider
              {...sliderSettings2}
              className="w-10/12 md:max-w-[850px] max-w-sm mx-auto"
            >
              {tabData[activeIdx].imgSrc.map((src, index) => {
                return (
                  <div>
                    <h3 className="opacity-0">1</h3>
                    <img
                      key={index}
                      src={src}
                      alt={index}
                      className="h-[450px] mx-auto"
                    />
                  </div>
                );
              })}
            </Slider> */}
            <SwitchTransition>
              <Transition
                appear={true}
                timeout={300}
                in={true}
                key={activeIdx}
                onExit={exitAnim}
                onEnter={enter}
                mountOnEnter
                unmountOnExit
              >
                <div>
                  <div className="absolute top-0 left-0 bottom-auto right-auto bg-verde/10 w-20 rounded hidden lg:block p-4 rounded-br-3xl">
                    <div className="flex items-center flex-col space-y-4">
                      {tabData[activeIdx].compatibility.map((elem, index) => {
                        return (
                          <div key={index}>
                            <Chip data={CompatibilityType[elem]} type="true" />
                          </div>
                        );
                      })}
                    </div>
                  </div>
                  {/* <div className='absolute left-0 bottom-0 w-28  bg-verde/10 p-4 rounded-tr-3xl'>
                  <div className='flex flex-col space-y-6'>
                      {tabData[activeIdx].use.map((elem, index) => {
                        return (
                          <div key={index}>
                            <Chip data={userType[elem]} userType="true"/>
                          </div>
                        );
                      })}
                    </div>
                  </div> */}
                  <div className="absolute bottom-auto right-0 left-auto top-0 hidden  p-4">
                    <div className="flex items-center py-2 sm:py-3 gap-3">
                      <div
                        onClick={() => {
                          openModal();
                          setProductTitle(tabData[activeIdx].title);
                        }}
                      >
                        <button className="btn-new font-semibold relative flex justify-center items-center rounded-full pl-12 pr-6 !h-[35px] text-sm font-poppins">
                          <span className="flex justify-center items-center">
                            <IoChevronForwardOutline className="h-[22px] w-[25px] ioArrow" />
                            <BsArrowRightShort className="h-[25px] w-[25px] tailArrow" />
                          </span>
                          Contact Us
                        </button>
                        {/* <Button title="Contact Us" /> */}
                      </div>

                      <div className="group cursor-pointer">
                        <a
                          href={tabData[activeIdx].fileLink}
                          target="_blank"
                          className="text-gray-600"
                        >
                          <button className="btn-new font-semibold relative flex justify-center items-center rounded-full pl-12 pr-6 !h-[35px] text-sm font-poppins">
                            <span className="flex justify-center items-center">
                              <IoChevronForwardOutline className="h-[22px] w-[25px] ioArrow" />
                              <BsArrowRightShort className="h-[25px] w-[25px] tailArrow" />
                            </span>
                            Brochure
                          </button>
                        </a>
                      </div>
                    </div>
                  </div>
                  <img
                    loading="lazy"
                    src={tabData[activeIdx].imgSrc}
                    alt={tabData[activeIdx].title}
                    className="mx-auto my-auto object-contain object-center mt-10 z-10 w-full h-[70%] md:h-[80%] lg:h-[85%]"
                  />
                </div>
              </Transition>
            </SwitchTransition>
          </div>
        </div>

        <div className="containers-min mx-auto lg:block hidden  absolute left-0 right-0 top-3 z-20 pb-0 lg:pb-0 xxl:pb-0">
          <div className="rounded-full w-full mb-1 xl:mb-2 bg-gray-200 bg-tab-shadow flex-wrap gap-3 items-center justify-around overflow-visible px-5 py-3 flex">
            {tabs.map((elem, index) => {
              return (
                <button
                  key={index}
                  onClick={() => setActiveIdx(index)}
                  className={` ${
                    activeIdx === index
                      ? 'bg-white text-black shadow'
                      : 'text-gray-600'
                  } text-black hover:text-green font-poppins text-base xl:text-lg rounded-full px-4 py-3 transition-colors duration-300`}
                >
                  {elem}
                </button>
              );
            })}
          </div>
        </div>
      </section>
      {isModalOpen && (
        <FormModal
          isModalOpen={isModalOpen}
          productTitle={productTitle}
          setIsModalOpen={setIsModalOpen}
        />
      )}
    </>
  );
}

// md:w-11/12 lg:w-10/12 xl:w-9/12 xxl:px-10 max-w-2xl mx-auto lg:block hidden  absolute left-0 right-0 bottom-1 z-20 pb-12 lg:pb-0 xxl:pb-0
